import { FC } from 'react'

import DataDog from '@/assets/logos/datadog.svg?react'
import ServiceIntegrationCard from '@/components/service-integration-card'
import { Logging } from '@/out/logging'
import { LoggingProps } from '@/pages/settings/logging'
import DatadogDetails from '@/pages/settings/logging/datadog/details'
import DatadogForm from '@/pages/settings/logging/datadog/form'

type Props = LoggingProps<'datadog'> & {
  configuration: Logging['datadog']
}

const DatadogIntegration: FC<Props> = ({
  configuration,
  onSetup,
  setupTimer,
  onTest,
  testTimer,
  onRemove,
  removeTimer,
}) => {
  return (
    <ServiceIntegrationCard
      title="Datadog"
      description="Monitor application performance and logs"
      icon={<DataDog className="w-8 h-8" />}
      iconColor="text-[#632CA6] dark:text-white"
      isConnected={!!configuration}
      setupContent={
        <DatadogForm
          setupTimer={setupTimer}
          testTimer={testTimer}
          onSetup={config => onSetup('datadog', config)}
          onTest={config => onTest('datadog', config)}
        />
      }
      manageContent={
        configuration && (
          <DatadogDetails configuration={configuration} timer={removeTimer} onRemove={() => onRemove('datadog')} />
        )
      }
    />
  )
}

export default DatadogIntegration
